import "./NotificationUI.css";

import { useEffect, useRef, useState } from "preact/hooks";
import { createPortal } from "react-dom";

import { useNotificationStore } from "./useNotificationStore";

export const NotificationUI = () => {
  const [state, setState] = useState({ slidingIn: false });
  const showingNotification = useRef(false);
  const { notifications, rewardNotification, removeFirst, clearRewardNotification } = useNotificationStore();
  const standardNotif = notifications[0];

  useEffect(() => {
    let animTimeout: ReturnType<typeof setTimeout>;

    if (standardNotif && !showingNotification.current) {
      const durationMs = standardNotif.duration * 1000;

      //Slide it onto screen
      setState((state) => ({ ...state, slidingIn: true }));
      showingNotification.current = true;
      animTimeout = setTimeout(() => {
        //Slide it off screen
        setState((state) => ({ ...state, slidingIn: false }));
        animTimeout = setTimeout(() => {
          //Remove this notification and mark as ready for next
          removeFirst();
          showingNotification.current = false;
        }, 1000);
      }, durationMs);
    }
    return () => {
      clearTimeout(animTimeout);
      showingNotification.current = false;
    };
  }, [removeFirst, standardNotif]);

  useEffect(() => {
    if (rewardNotification == undefined) return;
    // css doesn't have a way to simply reset an animation, so we have rely on tricks to do it
    const element = document.getElementById("reward-anim");
    if (element) {
      element.style.animation = "none";
      element.offsetHeight; // explicity trigger DOM reflow to force the browser to re-calculate style & layout
      element.style.animation = `rewardAnim ${rewardNotification.duration}s ease 0s 1 normal forwards`;

      setTimeout(() => {
        clearRewardNotification();
      }, rewardNotification.duration * 1000);
    }
  }, [rewardNotification, clearRewardNotification]);

  return createPortal(
    <div>
      <div notification-outer-container>
        <div notification-inner-container notification-slide-in={state.slidingIn}>
          <div notification-text-box className="supportsRtl">
            {standardNotif && standardNotif.imageUrl && (
              <div notification-image-border>
                <img notification-image src={standardNotif.imageUrl} />
              </div>
            )}
            {standardNotif && <div notification-text>{standardNotif.msg}</div>}
          </div>
        </div>
      </div>

      <div notification-outer-container>
        <div id="reward-anim" notification-inner-container reward-notification>
          <div reward-text-box className="supportsRtl">
            {rewardNotification && <div reward-text>🎉 {rewardNotification?.msg}</div>}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
